import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { HomeServicesNeedLoveInput } from '@/models/needLove';

export const postHomeServicesForm = async (data: HomeServicesNeedLoveInput) => {
  const response = await mutationExecute({
    variables: {
      data,
    },
    mutation: graphql(`
      mutation PostHomeServicesForm($data: HomeServicesInputType!) {
        postHomeServicesForm(data: $data)
      }
    `),
  });

  return response.data?.postHomeServicesForm ?? '';
};
